import { Alert, AlertProps } from '@mui/material'
import { useTranslation } from 'react-i18next'

const AlertHearingAidEvaluationAlreadyCompleted = (props: AlertProps) => {
  const { t } = useTranslation()
  return (
    <Alert {...props} severity="info" sx={{ textAlign: 'center' }}>
      {t('pages.appointment.messages.initialAppointmentAlreadyCompleted')}
      <br />
      {t('pages.appointment.messages.tryFollowUp')}
    </Alert>
  )
}

export { AlertHearingAidEvaluationAlreadyCompleted }
